import Navigation from '@/organisms/Beta/Navigation/Navigation';
import Footer from '@/organisms/Footer/Footer';
import LegacyNavigation from '@/organisms/Navigation/Navigation';

const PageLayout = ({editorsPicks, children}) => {
  return (
    <>
      {process.env.NEXT_PUBLIC_NAVIGATION === 'new' ? (
        <Navigation editorsPicks={editorsPicks} />
      ) : (
        <LegacyNavigation editorsPicks={editorsPicks} />
      )}

      {children}

      <Footer />
    </>
  );
};

export default PageLayout;
